<template>
    <div>
        <city-list v-if="!isBlock" @selectedCity="selectedCid"></city-list>
        <div class="maincon">
            <div class="blockbox">
                <el-switch v-model="showPic" inactive-text="覆盖物">
                </el-switch>
            </div>

            <div class="bmap-page-container">
                <el-bmap vid="bmapindex" :bmap-manager="bmapManager" :zoom="zoom" :center="center" :events="events"
                    class="bmap-demo">
                    <weixing-plugin :map="map"></weixing-plugin>

                    <el-bmap-ground-overlay ref="overlay" v-for="(groundimage, index) in groundimages"
                        :key="groundimage.file_id" :url="groundimage.url" :visible="groundimage.visible"
                        :bounds="groundimage.bounds" :opacity="groundimage.opacity" :events="groundimage.events">
                    </el-bmap-ground-overlay>


                </el-bmap>

            </div>

        </div>
    </div>
</template>

<script>

import weixingPlugin from '@/components/bmap/weixingPlugin.vue'
import VueBMap from "vue-bmap-gl";
import { lazyBMapApiLoaderInstance } from 'vue-bmap-gl';

import CityList from '@/components/cityreserch/CityList.vue'
import { mapPic, blockDetail } from '@/api/cityresearch'

let bmapManager = new VueBMap.BMapManager();



export default {
    components: {
        CityList,
        weixingPlugin
    },

    props: {
        isBlock: {
            type: Boolean,
            default: false
        },
        cate: {
            type: Number,
            default: 2  //国土1 //总体2 //板块详细规划3
        },//1 2 3
        polygondata: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    computed: {
        shi: {
            get() {
                return this.$store.state.shi
            },
            set(v) {
                this.$store.dispatch('changeShi', v)
            }
        },
        block: {
            get() {
                return this.$store.state.block
            },
            set(v) {
                this.$store.dispatch('changeBlock', v)
            }
        }
    },

    watch: {
        isBlock: {
            handler(v) {
                if (v) {
                    this.selectedCid(this.block)
                }
            }
        },

        showPic: {
            handler(v) {
                const changeOpacity = parseFloat(v / 100)
                //获取覆盖物
                // this.$refs.overlay.map(item => {
                //     console.log(item.$$getInstance().setOpacity(0.1))
                // })

                const current = JSON.parse(JSON.stringify(this.groundimages))
                const groundimagesall = current.map(item => {
                    item.visible = !item.visible
                    return item
                })

                console.log('groundimagesall', groundimagesall)

                this.groundimages = groundimagesall

                console.log(' this.groundimages ', this.groundimages)
            }


        },

        // shi: {
        //     handler(v) {
        //         this.getCenterPoint()
        //         this.getPICData()

        //     },
        //     deep: true
        // },

        block: {
            handler(v) {
                if (this.isBlock) {
                    this.selectedCid(v)
                }
            },
            immediate: true
        },

        polygondata: {
            handler(v) {
                this.getCenterPoint()


            },
            deep: true
        }
    },

    mounted() {

    },
    data() {
        return {
            opacityall: 1,
            showPic: true,
            area: '',
            pointsList: [
                {
                    id: 1,
                    name: '这是标题1',
                    lng_lat: {
                        lat: '1',
                        lng: '1'
                    },
                    imgurl: ''
                }
            ],
            visible: true,
            polygons: [],
            map: {},
            bmapManager,
            geodata: "",
            events: {
                init: (o) => {
                    this.map = o

                },
            },
            count: 1,
            center: [0, 0],
            zoom: 10,
            groundimages: [

            ]
        };
    },
    methods: {
        selectedCid(cid) {
            this.getCenterPoint(cid)
            this.getPICData(cid)

        },

        //获取地图的中心点
        getCenterPoint(cityplateid = 0) {
            let params;

            if (cityplateid) {
                params = { city_plate_id: cityplateid }
            } else {

                if (this.cate === 3) {
                    params = { city_plate_id: this.block }
                } else {
                    params = { city_plate_id: this.shi }
                }
            }


            blockDetail(params).then(res => {
                this.center = [res.data.lng, res.data.lat]
                this.zoom = 10;
            })

        },


        getPICData(cityplateid = 0) {

            let params;
            if (cityplateid) {
                params = { city_plate_id: cityplateid, type: this.cate }
            } else {
                if (this.cate === 3) {
                    params = { city_plate_id: this.block, type: this.cate }
                } else {
                    params = { city_plate_id: this.shi, type: this.cate }
                }
            }



            mapPic(params).then(res => {
                // console.log('res', res)
                // this.center = [res.data.lng, res.data.lat]
                // this.zoom = 15;

                this.handleResImges(res.data)


            })
        },

        handleResImges(data) {
            const groundimages = data.map(item => {
                const obj = {
                    file_id: item.file_id,
                    url: item.file_url,
                    visible: true,
                    opacity: 1,
                    bounds: [[item.sw.lng, item.ne.lat], [item.ne.lng, item.sw.lat]],
                    events: {
                        click(e) {
                            console.log('click overlay', e);
                            alert('click groundimage');
                        }
                    }
                }
                return obj
            })

            this.groundimages = groundimages


        }



    }


};
</script> 
<style lang="scss" scoped>
.bmap-page-container {
    width: 98%;
    margin-left: 1%;
}

.maincon {
    position: relative;
    height: calc(100vh - 180px);
}

.bmap-demo {
    height: calc(100vh - 180px);
}

.labelbox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    border-radius: 5px;

    .labelcontent {
        border: solid 1px #fff;
        background: #fff;
        border-radius: 4px;
        color: #333;
        font-size: 14px;
        padding: 4px;
        display: flex;
        flex-direction: row;
        padding: 5px 10px;
        justify-content: space-between;
        align-items: center;

        .iconimg {
            height: 30px;
            width: 30px;
        }

        .labeltext {
            margin-left: 10px;
        }

        // mar
    }

    .labeldown {
        width: 0;
        height: 0;
        border-top: 10px solid #fff;
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;

    }
}

.blockbox {
    height: 50px;
    width: 140px;
    position: absolute;
    top: 5%;
    right: 40px;
    z-index: 20;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
}
</style>